import script from "./ServicesOfferSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesOfferSection.vue?vue&type=script&setup=true&lang=js"

import "./ServicesOfferSection.vue?vue&type=style&index=0&id=b769a7ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b769a7ae"]])

export default __exports__